import React from 'react';
import { Button, ButtonGroup, Modal } from '@ver-uds/react';
import { Alert } from '@ver-uds/uswds-react';

export type DeleteHiringSiteModalProps = {
  open: boolean;
  close(): void;
  totalHiringSites: number;
  onSubmit: () => void;
};

const DeleteHiringSiteModal = ({
  open,
  close,
  totalHiringSites,
  onSubmit,
}: DeleteHiringSiteModalProps): JSX.Element => {
  const onDeleteHiringSite = () => {
    onSubmit();
    close();
  };

  const ModalFooter = (): JSX.Element | null => {
    if (totalHiringSites <= 1) {
      return null;
    }

    return (
      <Modal.Footer>
        <ButtonGroup>
          <Button type="button" variant="secondary" onClick={(): void => close()}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={onDeleteHiringSite}>
            Yes, Delete Hiring Site
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    );
  };

  return (
    <Modal
      id="delete-hiring-site-modal"
      header={totalHiringSites > 1 ? 'Delete Hiring Site?' : 'Cannot Delete Hiring Site'}
      open={open}
      close={close}
      fixedToTop
    >
      <Modal.Content>
        <Alert status="warning">
          <Alert.Text>
            {totalHiringSites > 1
              ? 'This action cannot be undone. Are you sure you want to permanently delete this Hiring Site?'
              : 'At least one hiring site is required.'}
          </Alert.Text>
        </Alert>
      </Modal.Content>
      <ModalFooter />
    </Modal>
  );
};

// istanbul ignore if: Not used for test environment; Modal.setAppElement should be called in the tests directly.
if (process.env.NODE_ENV !== 'test') {
  Modal.setAppElement('#root');
}

export default DeleteHiringSiteModal;
